import React from 'react';
export * from './fieldList';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
import { SourceType } from '../../../types';

/** test ids for form and sections inside it */
export var DEFAULT_SELECTED_SOURCE_TYPE = 0;
export var MISCELLANEOUS_FORM_TEST_ID = "miscellaneous-form-test-id";
export var SOURCE_TYPE_LABEL = 'Source type';
export var SOURCE_TYPE_TEST_ID = 'source-type-test-id';
export var SOURCE_TYPE_HELPER_TEXT = 'Change the source type if necessary.';
export var SOURCE_TITLE_LABEL = 'Source title';
export var SOURCE_TITLE_TEST_ID = 'source-title-test-id';
export var DESCRIPTION_LABEL = 'Description';
export var DESCRIPTION_TEST_ID = 'description-test-id';
export var UNIQUE_KEY_FOR_DATE_FIELD = 'date-field-key';
export var DATE_CREATED_LABEL = 'Date created';
export var DATE_CREATED_TEST_ID = 'date-created-test-id';
export var MISCELLANEOUS_FORM_PUB_INFO_SECTION_NAME = 'pubother';
export var MISCELLANEOUS_FORM_PUB_INFO_SECTION_TITLE = 'Miscellaneous publication info';
export var MISCELLANEOUS_FORM_PUB_INFO_TEST_ID = 'Miscellaneous-form-pub-info-test-id';
export var CitingOptions = {
  MiscellaneousSource: 'Miscellaneous source',
  OnlineSource: 'An online source',
  DigitalFile: 'A digital file (PDF, PPT, etc.)'
};
export var SourceTypeOptions = [{
  uuid: "".concat(SourceType.MISCELLANEOUS, "-id"),
  value: SourceType.MISCELLANEOUS,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.MiscellaneousSource)
}, {
  uuid: "".concat(SourceType.WEBSITE, "-id"),
  value: SourceType.WEBSITE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.OnlineSource)
}, {
  uuid: "".concat(SourceType.DIGITAL_FILE, "-id"),
  value: SourceType.DIGITAL_FILE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, CitingOptions.DigitalFile)
}];
export var CONTRIBUTOR_ROLE_OPTIONS = [FunctionTypes.AUTHOR, FunctionTypes.EDITOR, FunctionTypes.COMPILER, FunctionTypes.TRANSLATOR];